module.exports = __webpack_public_path__ + "static/media/100143.f711c1a1.png";